import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class OperationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'operation'}
            title={'PROCEDURE P21.0 OPERATION'}
            exportTitle={'<h2>Procedure P21.0 Operation</h2>'}
            exportFileName={'operation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OperationProcedure);
